
import { CashAcceptorStatusCode } from '@b2bsoft/kiosk-shell-sdk';
import { KioskApplication } from '../models/common/KioskApplication';
import { EventEmitter } from './EventEmitter';

export interface Sdk {
    currentAppFrame: HTMLIFrameElement | null;
    application: KioskApplication | null;
    events: EventEmitter;

    openApp(application: KioskApplication, target: any): Promise<any>;
    closeApp(reason: ApplicationCloseReason): Promise<any>;

    cashAcceptorStatusChanged(status: CashAcceptorStatusCode): Promise<any>;
    transactionChanged(data: any): Promise<any>;
    userActivity(): Promise<any>;
}

export enum SdkEvents {
    ApplicationOpened,
    ApplicationClosed,
    CashAcceptorStarted,
    CashAcceptorStopped,
    PrintReceiptStarted,
    UserActivity
}

export enum ApplicationCloseReason {
    HomeButtonClick = "HomeButtonClickk",
    IdleTimer = "IdleTimer",
    KioskOutOfOrder = "KioskOutOfOrder",
    NoInternetConnection = "NoInternetConnection",
    GoToPayment = "GoToPayment"
}